"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseNetworkError = exports.NetworkError = void 0;
var shared_1 = require("@cian/peperrors/shared");
/**
 * @deprecated
 *
 * @export
 * @class NetworkError
 * @extends {GenericError}
 */
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    function NetworkError(message, domain) {
        if (domain === void 0) { domain = 'unknown-domain.by-http-api'; }
        var _this = _super.call(this, { type: 'NetworkError', domain: domain, message: message }) || this;
        Object.setPrototypeOf(_this, NetworkError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, NetworkError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return NetworkError;
}(shared_1.GenericError));
exports.NetworkError = NetworkError;
/**
 * @deprecated
 *
 * @export
 * @class ResponseNetworkError
 * @extends {GenericError}
 */
var ResponseNetworkError = /** @class */ (function (_super) {
    __extends(ResponseNetworkError, _super);
    function ResponseNetworkError(message, domain) {
        if (domain === void 0) { domain = 'unknown-domain.by-http-api'; }
        var _this = _super.call(this, { type: 'ResponseNetworkError', domain: domain, message: message }) || this;
        Object.setPrototypeOf(_this, ResponseNetworkError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, ResponseNetworkError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return ResponseNetworkError;
}(shared_1.GenericError));
exports.ResponseNetworkError = ResponseNetworkError;
//# sourceMappingURL=networkError.js.map